import { render, staticRenderFns } from "./ChooseInsurance.vue?vue&type=template&id=7b5976c5&scoped=true"
import script from "./ChooseInsurance.vue?vue&type=script&lang=js"
export * from "./ChooseInsurance.vue?vue&type=script&lang=js"
import style0 from "./ChooseInsurance.vue?vue&type=style&index=0&id=7b5976c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5976c5",
  null
  
)

export default component.exports